import type {
  AddressResolution,
  AddressSuggestion,
} from "@/components/ui/address-autocomplete";

/**
 * What a chosen address suggestion changes on the billing information: street
 * line, city, province and postal code. Mirrors `fill()` in the Django app's
 * address-autocomplete.js with the billing form's `data-fill-*` targets.
 *
 * An address the server could not confirm keeps the suggestion's own text and
 * leaves the other fields as they were.
 */
export function billingAddressPatch(
  result: AddressResolution,
  suggestion: AddressSuggestion,
): { address: string; city?: string; province?: string; zip_code?: string } {
  if (!result.confirmed) return { address: suggestion.text };
  return {
    address: result.address || suggestion.text,
    ...(result.city ? { city: result.city } : {}),
    ...(result.province ? { province: result.province } : {}),
    ...(result.zip_code ? { zip_code: result.zip_code } : {}),
  };
}
